"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Author = exports.AuthorDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_1 = require("../elements/icon");
var icons_1 = require("../icons");
var Social = icons_1.Icons.Social;
var FacebookCircle = Social.FacebookCircle,
  TwitterCircle = Social.TwitterCircle,
  LinkedinCircle = Social.LinkedinCircle;
exports.AuthorDefaultProps = {
  label: 'By: '
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: ", " ", " ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: ", " ", " ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1), theme_1.theme.UNIT(3)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1), theme_1.theme.UNIT(4))
});
var SocialStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var BylineStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n    font-family: ", ";\n    font-style: italic;\n    font-weight: 400;\n    color: ", ";\n  "], ["\n    ", "\n    font-family: ", ";\n    font-style: italic;\n    font-weight: 400;\n    color: ", ";\n  "])), theme_1.theme.RESPONSIVE_FONT_SIZE('normal'), theme_1.theme.FONT('serif'), theme_1.theme.COLOR('text'))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme_1.theme.COLOR('bold'))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 24px;\n    height: 24px;\n  "], ["\n    width: 24px;\n    height: 24px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n  "], ["\n    width: 32px;\n    height: 32px;\n  "])))
});
var IconLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    cursor: pointer;\n    margin-left: ", ";\n    &:hover {\n      ", "\n    }\n  "], ["\n    cursor: pointer;\n    margin-left: ", ";\n    &:hover {\n      ", "\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.FILL('yellow'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Byline: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BylineStyles),
  Name: styled_components_1.default.b(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Social: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), SocialStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  IconLink: (0, styled_components_1.default)('a')(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), IconLinkStyles)
};
var Author = function (props) {
  var className = props.className,
    person = props.person,
    label = props.label;
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Byline, null, label, " ", React.createElement(My.Name, null, person.name)), React.createElement(My.Social, null, person.facebook && React.createElement(My.IconLink, {
    href: person.facebook,
    target: "_blank"
  }, React.createElement(My.Icon, {
    color: "text"
  }, React.createElement(FacebookCircle, null))), person.twitter && React.createElement(My.IconLink, {
    href: person.twitter,
    target: "_blank"
  }, React.createElement(My.Icon, {
    color: "text"
  }, React.createElement(TwitterCircle, null))), person.linkedin && React.createElement(My.IconLink, {
    href: person.linkedin,
    target: "_blank"
  }, React.createElement(My.Icon, {
    color: "text"
  }, React.createElement(LinkedinCircle, null)))));
};
exports.Author = Author;
exports.Author.defaultProps = exports.AuthorDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;